import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as IconCouple } from '../../media/icons/group.svg';
import { ReactComponent as IconLocation } from '../../media/icons/location.svg';
import { ReactComponent as IconDetails } from '../../media/icons/details.svg';
import { ReactComponent as IconArrow } from '../../media/icons/arrow_right.svg';


export default class Tripcarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            data: [],
            sample_picture_url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/colombia.webp"
        };
        this.updatePicture = this.updatePicture.bind(this);
    }


    componentDidMount() {
        if (this.state.data !== this.props.data) {
            this.setState({
                data: this.props.data
            });
        }
    }


    componentDidUpdate() {
        if (this.state.data !== this.props.data) {
            this.setState({
                data: this.props.data
            });
        }
    }


    updatePicture(trip_id, next = true) {
        var data = this.state.data;
        data.map(trip => {
            // Check if this is the trip
            if (trip.trip_id == trip_id) {
                var list = trip.pictures_all;
                if (next) {
                    list.push(list.shift());
                } else {
                    list.unshift(list.pop());
                }
                trip.pictures_all = list;
            }
        });
        this.setState({
            data: data
        })
    }


    render() {

        return (
            <div className="account__element account__tripcarousel-wrapper">

                {this.state.data && this.state.data.map((trip, index) => (
                    (trip.trip_id &&
                        <div key={index} className="tripcarousel__element">
                            {trip.collection && trip.collection.length >= 1 &&
                                <div className="tripcarousel__element__labelbar">
                                    {trip.collection.slice(0, 3).map((element, i) => (
                                        <div key={i} className="tripcarousel__element__labelbar__label">
                                            {element}
                                        </div>
                                    ))}
                                </div>
                            }
                            {(trip.pictures_all && trip.pictures_all.length >= 1) &&
                                <div className="tripcarousel__element__picture">
                                    {trip.pictures_all[0].filepath.endsWith(".mp4") ||
                                        trip.pictures_all[0].filepath.endsWith(".mov") ||
                                        trip.pictures_all[0].filepath.endsWith(".avi") ? (
                                        <video
                                            src={trip.pictures_all[0].filepath}
                                            alt={trip.pictures_all[0].label}
                                            className="tripcarousel__element__picture-inner"
                                            playsInline
                                            controls
                                            muted
                                            loop
                                            preload="auto"
                                        />
                                    ) : (
                                        <img
                                            src={trip.pictures_all[0].filepath}
                                            alt={trip.pictures_all[0].label}
                                            className="tripcarousel__element__picture-inner"
                                        />
                                    )}
                                    {trip.pictures_all && trip.pictures_all.length >= 2 &&
                                        <div onClick={() => this.updatePicture(trip.trip_id, false)} className="tripcarousel__element__picture__navbutton tripcarousel__element__picture__navbutton--left">
                                            <IconArrow className="tripcarousel__element__picture__navbutton-inner" />
                                        </div>
                                    }
                                    {trip.pictures_all && trip.pictures_all.length >= 2 &&
                                        <div onClick={() => this.updatePicture(trip.trip_id, true)} className="tripcarousel__element__picture__navbutton tripcarousel__element__picture__navbutton--right">
                                            <IconArrow className="tripcarousel__element__picture__navbutton-inner" />
                                        </div>
                                    }
                                </div>
                            }
                            {!(trip.pictures_all && trip.pictures_all.length >= 1) &&
                                <div className="tripcarousel__element__picture">
                                    {(trip.target && trip.target.length >= 1) &&
                                        <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/target+groups/" + trip.target[0].replace(' ', '+') + ".webp"} alt={"Guidr trip"} className={"tripcarousel__element__picture-inner"} />
                                    }
                                    {!(trip.target && trip.target.length >= 1) &&
                                        <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/target+groups/Solo.webp"} alt={"Guidr trip"} className={"tripcarousel__element__picture-inner"} />
                                    }
                                </div>
                            }
                            <div className="tripcarousel__element__content">
                                <div className="tripcarousel__element__contentbox tripcarousel__element__title">
                                    <Link to={"/trip/" + trip.trip_id} className="tripcarousel__element__title-inner text-bold">
                                        {trip.title}
                                    </Link>
                                </div>

                                {trip.cities && trip.cities.length >= 1 &&
                                    <div className="tripcarousel__element__contentbox tripcarousel__element__contentbox-flex">
                                        <div className="tripcarousel__element__contentbox__icon">
                                            <IconLocation className="tripcarousel__element__contentbox__icon-inner" />
                                        </div>
                                        <div className="tripcarousel__element__contentbox__label">
                                            <div className="tripcarousel__element__contentbox__label__element">
                                                {trip.cities.join(" | ")}
                                            </div>
                                        </div>
                                    </div>
                                }

                                {/* <div className="tripcarousel__element__contentbox tripcarousel__element__contentbox-flex">
                                <div className="tripcarousel__element__contentbox__icon"></div>
                                <div className="tripcarousel__element__contentbox__label">
                                    3-5 days | 16 activities
                                </div>
                            </div> */}

                                {(trip.target || trip.category) &&
                                    <div className="tripcarousel__element__contentbox tripcarousel__element__contentbox-flex">
                                        <div className="tripcarousel__element__contentbox__icon">
                                            <IconCouple className="tripcarousel__element__contentbox__icon-inner tripcarousel__element__contentbox__icon-inner--large" />
                                        </div>
                                        <div className="tripcarousel__element__contentbox__label">
                                            <div className="tripcarousel__element__contentbox__label__element">
                                                {trip.target.concat(trip.category).join(" | ")}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    )
                ))}


                {(!this.state.data) && [0, 1, 2].map((index) => (
                    <div key={index} className="tripcarousel__element tripcarousel__element--skeleton"></div>
                ))}

            </div>
        )
    }
}
